









import { Prop, Component, Vue, Watch, PropSync } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import { Company, getAllCompanies } from "@/api/company-api";
import SelectCompanyType from "@/components/SelectCompanyType.vue";

@Component({
  components: {
    SelectCompanyType
  }
})
export default class SelectCompany extends Vue {
  @Prop({ type: String }) value?: string;
  @Prop({ type: String }) size?: string;
  @Prop({ type: String }) companyType?: string;
  @Prop({ type: String, validator: companyCategoryValidator })
  category?: string;
  @Prop({ type: String, default: "全ての会社" }) defaultOptionText!: string;

  @PropSync("text", { type: String, default: "" }) textSync!: string;

  companyId: string = "";
  companies: Company[] = [];

  get options(): SelectOption[] {
    return [{ text: this.defaultOptionText, value: "" }].concat(
      this.companies.map(companyOption)
    );
  }

  @Watch("value", { immediate: true })
  onValueChanged(companyId: string) {
    this.companyId = companyId;
  }

  @Watch("category")
  onCategoryChanged() {
    this.initCompanyList();
  }

  @Watch("companyType")
  onCompanyTypeChanged() {
    this.initCompanyList();
    this.companyId = "";
  }

  public created() {
    this.initCompanyList();
  }

  input() {
    this.$emit("input", this.companyId);
    // textを得るためにsync使ってるけど、Vuexとかで取り直した方がいいかも
    this.textSync = this.getSelectedText();
  }

  private getSelectedText(): string {
    const option = this.options.find(o => o.value === this.companyId);
    return option ? option.text : "";
  }

  private async initCompanyList() {
    this.companies = await getAllCompanies({
      category: this.category,
      companyType: this.companyType
    });
  }
}

function companyOption(company: Company): SelectOption {
  return {
    text: company.name,
    value: String(company.office.officeId)
  };
}

function companyCategoryValidator(category?: string): boolean {
  return !category || ["client", "vendor"].includes(category);
}
